import { PLATFORM } from '@cx-sdk/constants';
import { z } from 'zod';

export const platformSchema = z.enum(Object.values(PLATFORM) as [keyof typeof PLATFORM, ...(keyof typeof PLATFORM)[]]);
export type Platform = z.infer<typeof platformSchema>;
